import { render, staticRenderFns } from "./NewLists.vue?vue&type=template&id=7fe8d412&scoped=true&"
import script from "./NewLists.vue?vue&type=script&lang=js&"
export * from "./NewLists.vue?vue&type=script&lang=js&"
import style0 from "./NewLists.vue?vue&type=style&index=0&id=7fe8d412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe8d412",
  null
  
)

export default component.exports